export enum LinkedInEventType {
	LINKEDIN_POPUP_READY,
	AUTHENTICATION_SERVICE_READY,
	LINKEDIN_USER_LOGGED_IN,
	LINKEDIN_ERROR_OCCURRED,
}
